
    <iframe [src]="sanitizer.bypassSecurityTrustResourceUrl(url)" height="100vh" width="100%" style="height: calc(100vh - 58px);"></iframe>
